export default __webpack_public_path__ + "static/features-panel1-cde4fe984420f4dfe6d05b063e0df7ff.png";